import React, { useContext, useMemo } from 'react';
import {
  Heading,
  Flex,
  Box,
  FormikField,
  FieldGroup,
  IconOption,
  Text,
} from '@feast-it/pesto';
import PropTypes from 'prop-types';
import { useTheme } from 'emotion-theming';

import SupplierContext from '../../../context/supplierSignUp';
import {
  TIER_1_ICONS_THIN,
  VERTICAL_ICONS_TOGATHER,
} from '../../../constants/verticals';
import { TOGATHER_THEME_NAME } from '../../../constants/togather';

const Tier1Service = props => {
  const { tier1Verticals } = useContext(SupplierContext);
  const theme = useTheme();
  const isNewBrand = theme.name === TOGATHER_THEME_NAME;

  const FIELDS = useMemo(
    () =>
      (tier1Verticals || []).map(vertical => ({
        label: vertical.name,
        value: vertical.sysName,
        icon: isNewBrand
          ? VERTICAL_ICONS_TOGATHER[vertical.sysName]
          : TIER_1_ICONS_THIN[vertical.sysName],
      })),
    [isNewBrand, tier1Verticals]
  );

  return (
    <Flex alignItems="center" justifyContent="center" flexDirection="column">
      <Box width="100%" maxWidth={600}>
        <Heading
          textAlign="center"
          mb={{ _: 2, m: 4 }}
          color="blueDark"
          fontSize={{ _: 'headingExtraLargeMobile', m: 'headingLargeMobile' }}
          lineHeight={{ _: 'headingExtraLargeMobile', m: 'headingLargeMobile' }}
          fontWeight={500}
        >
          What type of service do you offer?
        </Heading>

        <Text
          color="blueDark"
          textAlign="center"
          as="h2"
          mb={4}
          fontFamily="body"
          fontSize={{ _: 'body', m: 'headingMediumMobile' }}
          lineHeight={{ _: 'body', m: 'headingMediumMobile' }}
        >
          We work with a variety of the country’s very best suppliers. Let us
          know what you offer.
        </Text>
      </Box>

      <Box width="100%" maxWidth={650}>
        <FormikField
          as={FieldGroup}
          name="supplier.categories_tier1"
          onChange={selectedTier1 => props.onSelection(selectedTier1)}
          submitOnChange
        >
          <Flex justifyContent="center" flexWrap="wrap" fontFamily="body">
            {FIELDS.map(field => (
              <IconOption
                key={`tier-1-service-${field.value}`}
                {...field}
                icon={field.icon}
                label={field.label.replace(' and ', ' & ')}
                value={field.value}
                flexBasis={{ _: `${100 / 3}%`, m: '25%' }}
                size={{ _: 64, m: 92 }}
                px={{ _: 4, m: 6 }}
                py={5}
              />
            ))}
          </Flex>
        </FormikField>
      </Box>
    </Flex>
  );
};

Tier1Service.propTypes = {
  onSelection: PropTypes.func.isRequired,
};

export default Tier1Service;
